module.exports = __webpack_public_path__ + "static/Gotham-Black-a3025512bcbe1468c850347165d5004d.woff2";